import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';

//------------------------------------------------------------------------------
//              Отправить запрос на получение списка каналов
//------------------------------------------------------------------------------
export const getChannelsList = async () => {
  const url = `${ backendUrl }/api/alpha/channels/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении списка каналов: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка получения списка каналов: Error fetching get comments list:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx